// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 商品管理
import permissions from '@/views/permissions/index';
// 公司管理
import companys from '@/views/companys/companys';
// 回收站
import deleteList from '@/views/companys/deleteList';
// 城市管理
import citys from '@/views/citys/index';
// 区域管理
import district from '@/views/district/index';
// 小区管理
import community from '@/views/community/community';
// 身份管理(销售管理)
import identity from '@/views/identity/identity';
// 经理管理
import manager from '@/views/identity/manager';

// 用户管理
import user from '@/views/user/index';
// 角色管理
import role from '@/views/role/index';
// 基础管理
import base from '@/views/base/index';
// 分类管理
import classfiy from '@/views/information/classify';
// 文章管理
import article from '@/views/information/article'
// 话术管理
import script from '@/views/information/script'
// 视频管理
import video from '@/views/information/video'
// 标签组管理
import labelParent from '@/views/label/labelParent'
// 子标签管理
import labelChild from '@/views/label/labelChild'
// 车库管理
import garage from '@/views/garage/index'
// 车位类型管理
import carportType from '@/views/carportType/index'
// 楼栋管理
import building from '@/views/community/building'
// 房间管理
import room from '@/views/community/room'
// 车位
import parking from '@/views/garage/parking'
// 楼层
import floor from '@/views/garage/floor'
// 会员管理
import member from '@/views/member/member'
// 会员列表
import memberList from '@/views/member/memberList'
// 字典
import dict from '@/views/dict/index'
// 主页
import homepage from '@/views/homepage'
// 小区标签
import tag from '@/views/community/tag'
// 销售标签
import personTag from '@/views/identity/personTag'
// 事业线
import enterprise from '@/views/identity/enterprise'
// 评价管理
import evaluate from '@/views/identity/evaluate'
// 数据大屏
import fullPage from '@/views/fullPage/index'
// 数据大屏
import fullPage1 from '@/views/fullPage/index1'
// 数据大屏
import fullPage2 from '@/views/fullPage/index11'
// 数据大屏2
import pFullPage from '@/views/pFullPage/index'
// 数据搭配切换颜色
import PageColor from '@/views/fullPage/index2'
// 海报管理
import poster from '@/views/information/poster'
// 日历海报
import posterDay from '@/views/information/poster_day'
// 商学院 文章管理
import businsArt from '@/views/business/artic'
// 商学院 视频管理
import businsVideo from '@/views/business/video'
// 商学院 分类管理
import cartory from '@/views/business/cateGory'
// 活动管理
import actCreated from '@/views/actManger/actCreated'
// 规则引擎
// 客户评分规则
import customerRule from '@/views/ruleEngine/customerRule'
// 客户跟进规则
import followRule from '@/views/ruleEngine/followRule'
// 客户分配规则
import assignmentRule from '@/views/ruleEngine/assignmentRule'
// 顾问评分规则
import salorRule from '@/views/ruleEngine/salorRule'
// 活动板块
// 开盘大师
import freeParking from '@/views/active/freeParking'
// 电销短信
// 电销
import aiCall from '@/views/actAICallSms/aiCall'
// 电销流程及短信策略
import aiFlowSms from '@/views/actAICallSms/aiFlowSms'
// 短信营销
import sms from '@/views/actAICallSms/sms'
// 营销营销
import yx_sms from '@/views/actAICallSms/yx_sms'
// 费用管理
import feiyong from '@/views/feiyong/index'
// 团队管理
import group from '@/views/group/group'
// 合同管理
// 驾驶舱
import yingshou from '@/views/hetong/yingshou'
// 合同列表
import hetonglist from '@/views/hetong/hetonglist'


// 启用路由
Vue.use(Router);
var Routes = [{
	path: '/',
	name: '',
	component: login,
	hidden: true,
	meta: {
		requireAuth: false
	}
}, {
	path: '/login',
	name: '登录',
	component: login,
	hidden: true,
	meta: {
		requireAuth: false
	}
}, {
	path: '/pFullPage',
	name: '大屏2',
	component: pFullPage,
	hidden: true,
	meta: {
		requireAuth: false
	}
}, {
	path: '/pageColor',
	name: '大屏颜色',
	component: PageColor,
	hidden: true,
	meta: {
		requireAuth: false
	}
}, {
	path: '/fullPage',
	name: '大屏',
	component: fullPage,
	hidden: true,
	meta: {
		requireAuth: false
	}
}, {
	path: '/fullPage1',
	name: '大屏',
	component: fullPage1,
	hidden: true,
	meta: {
		requireAuth: false
	}
}, {
	path: '/fullPage2',
	name: '大屏',
	component: fullPage2,
	hidden: true,
	meta: {
		requireAuth: false
	}
}, {
	path: '/index',
	name: '首页',
	component: index,
	iconCls: 'el-icon-tickets',
	children: [{
		path: '/homePage',
		name: '主页',
		component: homepage,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/companys/companys',
		name: '公司管理',
		component: companys,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/companys/companys',
		name: '公司列表',
		component: companys,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/group/group',
		name: '团队列表',
		component: group,
		meta: {
			requireAuth: true
		}	
	}, {
		path: '/permissions/index',
		name: '权限管理',
		component: permissions,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/companys/deleteList',
		name: '回收站',
		component: deleteList,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/citys/index',
		name: '城市管理',
		component: citys,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/district/index',
		name: '区域管理',
		component: district,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/community/community',
		name: '小区管理',
		component: community,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/community/room',
		name: '房间管理',
		component: room,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/community/building',
		name: '楼栋管理',
		component: building,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/community/tag',
		name: '小区标签',
		component: tag,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/identity/identity',
		name: '身份管理(销售管理)',
		component: identity,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/identity/manager',
		name: '身份管理(经理管理)',
		component: manager,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/user/index',
		name: '用户管理',
		component: user,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/role/index',
		name: '角色管理',
		component: role,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/base/index',
		name: '基础管理',
		component: base,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/information/classify',
		name: '分类管理',
		component: classfiy,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/information/article',
		name: '文章管理',
		component: article,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/information/script',
		name: '话术管理',
		component: script,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/information/video',
		name: '视频管理',
		component: video,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/label/labelParent',
		name: '标签组管理',
		component: labelParent,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/label/labelChild',
		name: '子标签管理',
		component: labelChild,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/garage/index',
		name: '车库管理',
		component: garage,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/carportType/index',
		name: '车位类型',
		component: carportType,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/garage/parking',
		name: '车位管理',
		component: parking,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/garage/floor',
		name: '楼层管理',
		component: floor,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/member/member',
		name: '会员管理',
		component: member,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/dict/index',
		name: '字典项',
		component: dict,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/member/memberList',
		name: '会员列表',
		component: memberList,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/identity/personTag',
		name: '评价列表',
		component: personTag,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/identity/enterprise',
		name: '事业线',
		component: enterprise,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/identity/evaluate',
		name: '评价管理',
		component: evaluate,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/information/poster',
		name: '海报管理',
		component: poster,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/information/poster_day',
		name: '日历海报',
		component: posterDay,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/business/artic',
		name: '商学院文章管理',
		component: businsArt,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/business/video',
		name: '商学院视频管理',
		component: businsVideo,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/business/cateGory',
		name: '商学院分类管理',
		component: cartory,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/actManger/actCreated',
		name: '活动管理',
		component: actCreated,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/ruleEngine/customerRule',
		name: '客户评分规则',
		component: customerRule,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/ruleEngine/followRule',
		name: '客户跟进规则',
		component: followRule,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/ruleEngine/assignmentRule',
		name: '客户分配规则',
		component: assignmentRule,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/ruleEngine/salorRule',
		name: '顾问频分规则',
		component: salorRule,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/active/freeParking',
		name: '开盘大师',
		component: freeParking,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/hetong/yingshou',
		name: '财务概览',
		component: yingshou,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/hetong/hetonglist',
		name: '合同列表',
		component: hetonglist,
		meta: {
			requireAuth: true
		}	
	}, {
		path: '/actAICallSms/aiCall',
		name: 'AI电销',
		component: aiCall,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/actAICallSms/sms',
		name: '促活短信',
		component: sms,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/actAICallSms/yx_sms',
		name: '营销短信',
		component: yx_sms,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/actAICallSms/aiFlowSms',
		name: 'AI电销流程管理',
		component: aiFlowSms,
		meta: {
			requireAuth: true
		}
	}, {
		path: '/feiyong/index',
		name: '费用管理',
		component: feiyong,
		meta: {
			requireAuth: true
		}
	}]
}]
// 导出路由 
export default new Router({
	routes: Routes
})


// WEBPACK FOOTER //
// ./src/router/index.js